import { createContainer } from 'react-sweet-state';
import type { ConversationStateContainerProps } from './types';

export const ConversationStateContainer = createContainer<ConversationStateContainerProps>();
